import { StyleSheet } from "react-native";
import { theme } from "../../../../theme";
export const styles = StyleSheet.create({
    container: {
        position: "relative",
    },
    input: {
        position: "relative",
        padding: theme.spacing.xsmall,
        backgroundColor: theme.colors.light.base,
        borderWidth: 1,
        borderColor: theme.colors.greyscale.lighter,
        ...theme.fontDefaults.small,
        width: "100%",
        height: theme.spacing.xlarge,
        borderRadius: theme.spacing.xsmall2,
    },
    onFocus: {
        borderColor: theme.colors.focus.base,
    },
    disabled: {
        color: theme.colors.greyscale.light,
        borderColor: theme.colors.greyscale.lightest,
        backgroundColor: theme.colors.greyscale.lightest,
    },
    inputPrefix: {
        padding: theme.spacing.xsmall,
        paddingLeft: theme.spacing.large,
    },
    error: {
        borderColor: theme.colors.negative.base,
    },
    success: {
        borderColor: theme.colors.positive.base,
    },
    prefix: {
        position: "absolute",
        top: "10%",
        transform: [{ translateY: -50 }],
        left: theme.spacing.small,
    },
});
//# sourceMappingURL=InputText.styles.js.map